/**
 * Verify custom field
 *
 * @param {*} currentStep
 * @returns
 */
function verifyCustomField(currentStep) {
  let status = true;
  let forcusInput = null;

  const inputs = document.querySelectorAll(`[data-step="${currentStep}"] .bw-customfield-step-group .bw-field-form input`);
  if (inputs) {
    inputs.forEach(input => {
      if (input.value === '' && input.classList.contains('required')) {
        input.classList.add('error');
        status = false;

        if (forcusInput === null) {
          forcusInput = input;
        }
      } else {
        input.classList.remove('error');
      }
    });
  }

  if (!status && forcusInput !== null) {
    forcusInput.focus();
  }

  return status;
}


document.addEventListener('DOMContentLoaded', function () {

  // Get configurator block and paper preview
  const bwConfiguratorBlock = document.querySelector('.js-bw-configurator-block');
  const bwPaperPreview = document.querySelector('.js-bw-paper-preview');

  // Check if configurator block and paper preview exists
  const targetAddToCartForm = bwConfiguratorBlock.getAttribute('data-target');
  const targetImageGallery = bwPaperPreview.getAttribute('data-target');

  // Get product form and gallery
  const productForm = document.querySelector(targetAddToCartForm);
  const productGallery = document.querySelector(targetImageGallery);

  const lastPreview = document.querySelector('.bw-paper-preview-last');

  // Check if product form and gallery exists
  if (!productForm || !productGallery) {
    return;
  }

  // Get add to cart button
  const addToCartBtn = productForm.querySelector('[type="submit"]');
  // Disable submit button
  addToCartBtn.classList.add('disabled');
  addToCartBtn.setAttribute('disabled', true);

  // Add class to enable configurator
  productForm.classList.add('bw-configuration-enable');
  productGallery.classList.add('has-configuration');

  // Hide gallery when paper preview is active
  Array.from(productGallery.children).forEach(childGallery => {
    childGallery.classList.add('bw-hide-when-paper-preview');
  });

  // Add configurator block and paper preview
  productForm.insertBefore(bwConfiguratorBlock, productForm.firstChild);
  productGallery.appendChild(bwPaperPreview);

  // Toogle configurator show/hide
  document.querySelector('.bw-configurator-btn').addEventListener('click', function () {
    document.querySelector('.bw-configurator').classList.toggle('active');
    document.querySelector('.bw-paper-preview').classList.toggle('active');
    document.querySelector('.product-gallery.has-configuration').classList.toggle('active');
  });

  // Get all headers
  const headers = document.querySelectorAll('.bw-accordion-header');

  // Accordion
  headers.forEach(header => {
    header.addEventListener('click', function () {

      const currentStep = this.parentNode.getAttribute('data-step');
      let status = verifyCustomField(currentStep - 1);

      if (!status) {
        return;
      }

      // Update breadcrumbs
      document.querySelector(`.bw-paper-step-breadcrumbs .view-step > div.active`).classList.remove('active');
      document.querySelector(`.bw-paper-step-breadcrumbs .view-step > div.step-${currentStep}`).classList.add('active');

      const content = this.nextElementSibling;

      if (content.style.display === 'block') {
        content.style.display = 'none';
      } else {
        document.querySelectorAll('.bw-accordion-content').forEach(item => {
          item.style.display = 'none';
        });
        content.style.display = 'block';
      }

      document.querySelectorAll('.bw-paper-step').forEach(item => {
        item.style.display = 'none';
      });
      document.querySelector(`.bw-paper-step[data-step="${currentStep}"]`).style.display = 'block';
    });
  });

  // Next and prev buttons
  const nextPrevBtn = document.querySelectorAll('.bw-customfield-btn');
  nextPrevBtn.forEach(btn => {
    btn.addEventListener('click', function () {
      const step = this.getAttribute('data-step');

      if (step == 4) {
        let verify = verifyCustomField(step - 1);
        if (verify) {
          lastPreview.appendChild(bwPaperPreview);

          const headerOffset = document.querySelector('header').offsetHeight;
          const elementPosition = lastPreview.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          // Scroll to the calculated position smoothly
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      } else {
        const header = document.querySelector(`[data-step="${step}"] .bw-accordion-header`);
        header.click();
      }

    });
  });


  // Custom select field
  const selectElements = document.querySelectorAll('.bw-customfield-select');

  // Loop through all select elements and create custom select
  selectElements.forEach(selectElement => {
    const isColors = selectElement.classList.contains('is-colors');
    const isFonts = selectElement.classList.contains('is-fonts');
    const options = selectElement.querySelectorAll('option');

    // Create custom select wrapper
    const customSelectWrapper = document.createElement('div');
    customSelectWrapper.classList.add('bw-custom-select-wrapper');

    // Create custom select element
    const customSelect = document.createElement('div');
    customSelect.classList.add('bw-custom-select');

    // Create custom select trigger
    const customSelectTrigger = document.createElement('div');
    customSelectTrigger.classList.add('bw-custom-select-trigger');
    customSelectTrigger.textContent = options[0].textContent;

    if (isColors) {
      let customSpan = document.createElement('span');
      customSpan.style.backgroundColor = options[0].getAttribute('data-color');
      customSelectTrigger.insertBefore(customSpan, customSelectTrigger.firstChild);
    }

    if (isFonts) {
      customSelectTrigger.setAttribute('data-font', options[0].value.toLowerCase());
    }

    // Create custom options container
    const customOptions = document.createElement('div');
    customOptions.classList.add('bw-custom-options');

    // Create custom options
    options.forEach(option => {
      const customOption = document.createElement('span');
      customOption.classList.add('bw-custom-option');
      customOption.textContent = option.textContent;
      customOption.dataset.value = option.value;

      if (isColors) {
        let customSpan = document.createElement('span');
        customSpan.style.backgroundColor = option.getAttribute('data-color');
        customOption.insertBefore(customSpan, customOption.firstChild);
      }

      if (isFonts) {
        customOption.setAttribute('data-font', option.value.toLowerCase());
      }

      customOptions.appendChild(customOption);

    });

    // Append elements to the custom select
    customSelect.appendChild(customSelectTrigger);
    customSelect.appendChild(customOptions);
    customSelectWrapper.appendChild(customSelect);

    // Add child the original select element with the custom select
    selectElement.style.display = 'none';
    selectElement.parentNode.appendChild(customSelectWrapper, selectElement);

    // Add event listeners
    customSelectTrigger.addEventListener('click', function () {
      customOptions.classList.toggle('open');
    });

    // Get custom options and listen click event
    customOptions.querySelectorAll('.bw-custom-option').forEach(option => {
      option.addEventListener('click', function () {
        customSelectTrigger.textContent = this.textContent;
        customOptions.classList.remove('open');
        selectElement.value = this.dataset.value;
        selectElement.dispatchEvent(new Event('change')); // Trigger change event
        selectedOption = selectElement.options[selectElement.selectedIndex];

        if (isColors) {
          let customSpan = document.createElement('span');
          customSpan.style.backgroundColor = selectedOption.getAttribute('data-color');
          customSelectTrigger.insertBefore(customSpan, customSelectTrigger.firstChild);
        }

        if (isFonts) {
          customSelectTrigger.setAttribute('data-font', selectedOption.value.toLowerCase());
        }

      });
    });

    // Close custom options when click outside
    document.addEventListener('click', function (e) {
      if (!customSelect.contains(e.target)) {
        customOptions.classList.remove('open');
      }
    });
  });

  // Custom field input
  const customFieldInputs = document.querySelectorAll('.bw-configurator .bw-field-form input[type="text"]');
  if (customFieldInputs) {
    customFieldInputs.forEach(input => {

      const currentStep = input.closest('.bw-customfield-step').getAttribute('data-step');
      const target = input.getAttribute('data-target');
      const elementTarget = document.querySelector(`[data-step="${currentStep}"].bw-paper-step ${target}`);

      if (elementTarget) {
        input.addEventListener('keyup', function (event) {
          if (event.key === 'Enter') {
              event.preventDefault();
              console.log('Enter key press prevented');
          }
          elementTarget.textContent = this.value;
        });
      }

    });
  }

  // Custom field select
  const customFieldSelects = document.querySelectorAll('.bw-configurator .bw-field-form select');
  if (customFieldSelects) {
    customFieldSelects.forEach(select => {
      const isColors = select.classList.contains('is-colors');
      const isFonts = select.classList.contains('is-fonts');

      const currentStep = select.closest('.bw-customfield-step').getAttribute('data-step');
      const elementTarget = document.querySelector(`[data-step="${currentStep}"].bw-paper-step`);

      if (isFonts) {
        select.addEventListener('change', function () {
          if (elementTarget) {
            elementTarget.querySelector('.bw-texttop').style.fontFamily = select.value;
            elementTarget.querySelector('.bw-textbottom').style.fontFamily = select.value;
          }

          // Set font to other select
          if (currentStep == 1) {
            let jsCustomfieldFont2 = document.querySelector('#js-customfield-font-2');
            let jsCustomfieldFont3 = document.querySelector('#js-customfield-font-3');

            jsCustomfieldFont2.value = select.value;
            jsCustomfieldFont2.parentNode.querySelector('.bw-custom-select-trigger').setAttribute('data-font', select.options[select.selectedIndex].value.toLowerCase());
            jsCustomfieldFont2.parentNode.querySelector('.bw-custom-select-trigger').textContent = select.options[select.selectedIndex].textContent;

            jsCustomfieldFont3.value = select.value;
            jsCustomfieldFont3.parentNode.querySelector('.bw-custom-select-trigger').setAttribute('data-font', select.options[select.selectedIndex].value.toLowerCase());
            jsCustomfieldFont3.parentNode.querySelector('.bw-custom-select-trigger').textContent = select.options[select.selectedIndex].textContent;

            const eventChange = new Event('change');
            jsCustomfieldFont2.dispatchEvent(eventChange);
            jsCustomfieldFont3.dispatchEvent(eventChange);
          }
        });
      }

      if (isColors) {
        select.addEventListener('change', function () {
          if (elementTarget) {
            let color = this.options[this.selectedIndex].getAttribute('data-color');
            elementTarget.querySelector('.bw-texttop').style.color = color;
            elementTarget.querySelector('.bw-textbottom').style.color = color;
          }

          // Set font to other select
          if (currentStep == 1) {
            let jsCustomfieldColor2 = document.querySelector('#js-customfield-font-color-2');
            let jsCustomfieldColor3 = document.querySelector('#js-customfield-font-color-3');

            jsCustomfieldColor2.value = select.value;
            jsCustomfieldColor2.parentNode.querySelector('.bw-custom-select-trigger').innerHTML = `<span style="background-color: ${select.options[select.selectedIndex].getAttribute('data-color')};"></span>${select.options[select.selectedIndex].textContent}`;

            jsCustomfieldColor3.value = select.value;
            jsCustomfieldColor3.parentNode.querySelector('.bw-custom-select-trigger').innerHTML = `<span style="background-color: ${select.options[select.selectedIndex].getAttribute('data-color')};"></span>${select.options[select.selectedIndex].textContent}`;

            const eventChange = new Event('change');
            jsCustomfieldColor2.dispatchEvent(eventChange);
            jsCustomfieldColor3.dispatchEvent(eventChange);
          }
        });
      }

    });
  }

  // Zoom paper
  document.querySelectorAll('.bw-paper-preview .zoom').forEach(zoomBtn => {
    zoomBtn.addEventListener('click', function (e) {
      e.preventDefault();
      let step = e.target.closest('.bw-paper-step').getAttribute('data-step');
      e.target.closest('.bw-paper-preview').classList.add('opened');
      e.target.closest('.bw-paper-preview').querySelector(`[data-step="${step}"].bw-paper-step`).classList.add('active');
    });
  });

  // Close modal
  document.querySelectorAll('.bw-paper-preview .close').forEach(closeBtn => {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      let step = e.target.closest('.bw-paper-step').getAttribute('data-step');
      e.target.closest('.bw-paper-preview').querySelector(`[data-step="${step}"].bw-paper-step`).classList.remove('active');
      e.target.closest('.bw-paper-preview').classList.remove('opened');
    });
  });

  // Checkbox confirmation
  const secondAddToCartBtn = document.querySelector('.bw-customfield-btn-add-to-cart');
  document.querySelector('.js-bw-checkbox-confirmation').addEventListener('change', function (e) {
    if (e.target.checked) {
      secondAddToCartBtn.classList.remove('disabled');
      secondAddToCartBtn.removeAttribute('disabled');

      addToCartBtn.classList.remove('disabled');
      addToCartBtn.removeAttribute('disabled');
      // document.querySelector(`${targetAddToCartForm}.bw-configuration-enable`).classList.add('ready');
    } else {
      secondAddToCartBtn.classList.add('disabled');
      secondAddToCartBtn.setAttribute('disabled', true);

      addToCartBtn.classList.add('disabled');
      addToCartBtn.setAttribute('disabled', true);
      // document.querySelector(`${targetAddToCartForm}.bw-configuration-enable`).classList.remove('ready');
    }
  });

  // Add to cart button
  document.querySelector('.bw-customfield-btn-add-to-cart').addEventListener('click', function (e) {
    e.preventDefault();
    if (e.disabled) {
      return;
    }

    addToCartBtn.click(); // Trigger add to cart button
  });

  document.querySelectorAll('.bw-paper-action .edit-step').forEach(edit => {
    edit.addEventListener('click', function (e) {
      e.preventDefault();
      let step = e.target.getAttribute('data-step');
      let accordionHeader = document.querySelector(`[data-step="${step}"] .bw-accordion-header`);

      const headerOffset = document.querySelector('header').offsetHeight;
      const elementPosition = accordionHeader.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      // Scroll to the calculated position smoothly
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });

      // Open accordion
      accordionHeader.click();

      // Move paper preview up
      productGallery.appendChild(bwPaperPreview);

    });
  });

});

